import React, { useState, useEffect } from 'react';
import Globals from '../Globals';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';

import { doc, updateDoc, arrayRemove, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase";

const DeletePlayer = (setCurrentTask, currentTask, setPlayers, players, teamName, selectedPlayerName) => {
    // setCurrentTask={setCurrentTask} currentTask={currentTask}/>}
    const [errorDeleting, setErrorDeleting] = useState(false);
    const [authorizedEmails, setAuthorizedEmails] = useState([]);
    const [warningMessages, setWarningMessages] = useState([]);

    React.useEffect(() => {
        const loadAuthorizedEmails = async () => {
            if (currentTask !== Globals.taskNumbers.remove) {
                setAuthorizedEmails([]);
                return;
            }

            try {
                const docRef = doc(db, "teams", teamName);
                const snap = await getDoc(docRef);
                if (snap.exists()) {
                    const emails = snap.data().authorizedEmails;
                    setAuthorizedEmails(Array.isArray(emails) ? emails.map(e => String(e).toLowerCase()) : []);
                } else {
                    setAuthorizedEmails([]);
                }
            } catch (err) {
                console.error('Failed to load authorized emails', err);
                setAuthorizedEmails([]);
            }
        };

        loadAuthorizedEmails();
    }, [teamName, currentTask]);

    React.useEffect(() => {
        const player = players.find(v => v.name === selectedPlayerName);
        const currentEmail = auth?.currentUser?.email ? String(auth.currentUser.email).toLowerCase() : null;
        const playerEmail = player?.email ? String(player.email).toLowerCase() : null;
        const warnings = [];

        if (playerEmail && authorizedEmails.includes(playerEmail)) {
            if (authorizedEmails.length === 1) {
                warnings.push('This player is the last authorized team email. Removing them will lock the team and prevent access from the app.');
            }
            if (currentEmail && playerEmail === currentEmail) {
                warnings.push('You are deleting your own signed-in account from this team. You may lose access immediately after this removal.');
            }
        } else if (currentEmail && playerEmail === currentEmail) {
            warnings.push('You are deleting your own signed-in account from this team. You may lose access immediately after this removal.');
        }

        setWarningMessages(warnings);
    }, [players, selectedPlayerName, authorizedEmails]);

    const deletePlayerFromRoster = async (e) => {
        
        e.preventDefault();
        // console.log(e);
        if(e.currentTarget.querySelector('#removePlayerWithName').value === selectedPlayerName){
            const docRef = doc(db, "teams", teamName);
            const playerInfo = players.filter(v => v.name === selectedPlayerName);
            const player = playerInfo[0];
            console.log('playerInfo :', playerInfo);
            const playerEmail = player?.email ? String(player.email).toLowerCase() : null;
            const newPlayersList = players.filter(v => v.name !== selectedPlayerName);

            try {
                // Remove player from roster
                await updateDoc(docRef, {
                    players: arrayRemove({ ...player })
                });

                // Safely remove player's email from authorizedEmails only if it won't leave the team without any authorized emails
                if (playerEmail) {
                    const snap = await getDoc(docRef);
                    const currentAuthEmails = (snap.exists() && Array.isArray(snap.data().authorizedEmails)) ? snap.data().authorizedEmails.map(e => String(e).toLowerCase()) : [];
                    const currentUserEmail = auth?.currentUser?.email ? String(auth.currentUser.email).toLowerCase() : null;

                    if (currentAuthEmails.includes(playerEmail)) {
                        if (currentAuthEmails.length > 1) {
                            // Safe to remove
                            await updateDoc(docRef, {
                                authorizedEmails: arrayRemove(playerEmail)
                            });
                        } else {
                            // Skip removal to avoid leaving the team without any authorized emails
                            setErrorDeleting(true);
                            // restore local players list since we didn't fully remove authorization info
                            setPlayers(players);
                            return;
                        }
                    }
                }

                // Update local players state after successful removal
                setPlayers(newPlayersList);
                setCurrentTask(Globals.taskNumbers.none);
            } catch (err) {
                console.error('Failed to delete player', err);
                setErrorDeleting(true);
                // Optionally reload players from server or revert UI changes
            }
        }else{
            setErrorDeleting(true);
        }
    }

    return (
        <Modal show={currentTask === Globals.taskNumbers.remove} onHide={() => setCurrentTask(Globals.taskNumbers.none)}>
            <Form onSubmit={deletePlayerFromRoster}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Player</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <Form.Group>
                            <Form.Label className="mb-3">Type <b>{selectedPlayerName}</b> to confirm the delete action.</Form.Label>
                            {warningMessages.length > 0 && (
                                <div className="alert alert-warning">
                                    <strong>Warning:</strong>
                                    <ul className="mb-0">
                                        {warningMessages.map((message, idx) => (
                                            <li key={idx}>{message}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <Form.Control id="removePlayerWithName" type="input" required placeholder={selectedPlayerName}></Form.Control>
                        </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" type='submit'>
                        Delete
                    </Button>
                    <Button variant="secondary" onClick={() => setCurrentTask(Globals.taskNumbers.none)}>
                        Cancel
                    </Button>
                </Modal.Footer>                 
            </Form>
            <div className="toast-container position-fixed bottom-0 end-0 p-3">
                <Toast show={errorDeleting} onClose={() => setErrorDeleting(!errorDeleting)} delay={3000} autohide bg='danger'>
                    <Toast.Body>Player not deleted, please try again.</Toast.Body>
                </Toast>
            </div>
        </Modal>
    )
}

export default DeletePlayer;
